<div class="dialog--title" cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane" [cdkDragFreeDragPosition]="position" (cdkDragEnded)="onDragEnded($event)">
  <h6 mat-dialog-title>
    {{ data.sysText.sendNewEmailDialog_title | titlecase}}
  </h6>
  @if (isMobile$ | async) {
    <span class="spacer"></span>
    <button type="button" class="button-reset" (click)="close()" [attr.aria-label]="data.sysText.sendNewEmailDialog_cancel" [disabled]="isSubmitting$ | async">
      <mat-icon class="button-icon">close</mat-icon>
    </button>
  }
</div>

<mat-dialog-content>

  <!-- Recipients -->
  <mat-expansion-panel
    class="info-panel remove-mat-expansion-panel-padding"
    (opened)="recipientsOpenState = true"
    (closed)="recipientsOpenState = false"
    [expanded]="recipientsOpenState">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <div class="section-header-container">
          <p class="overline grey1 semibold section-title">
            {{data.sysText.sendNewEmailDialog_recipients | uppercase}}
            @if (form.controls.to.controls.recipientBoxChips.value.length > 0) {
              <span class="grey3 caption">
                {{ form.controls.to.controls.recipientBoxChips.value.length }} selected
              </span>
            }
          </p>
          <mat-divider class="section-header-underline" aria-hidden="true"></mat-divider>
        </div>
      </mat-panel-title>
    </mat-expansion-panel-header>

    <div class="panel-content">
      <app-add-recipients
        [formGroup]="form.controls.to"
        [sysText]="data.sysText"
        [boxLabel]="data.sysText.sendNewEmailDialog_to"
        [dialogData]="data.dialogData">
      </app-add-recipients>
    </div>
  </mat-expansion-panel>

  <!-- Add Cc -->
  <mat-expansion-panel
    class="info-panel remove-mat-expansion-panel-padding"
    (opened)="addCcOpenState = true"
    (closed)="addCcOpenState = false"
    [expanded]="addCcOpenState">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <div class="section-header-container">
          <p class="overline grey1 semibold section-title">
            {{data.sysText.sendNewEmailDialog_addCc}}
            @if (form.controls.cc.controls.recipientBoxChips.value.length > 0) {
              <span class="grey3 caption">
                {{ form.controls.cc.controls.recipientBoxChips.value.length }} selected
              </span>
            }
          </p>
          <mat-divider class="section-header-underline" aria-hidden="true"></mat-divider>
        </div>
      </mat-panel-title>
    </mat-expansion-panel-header>

    <div class="panel-content">
      <app-add-recipients
        [formGroup]="form.controls.cc"
        [sysText]="data.sysText"
        [boxLabel]="data.sysText.sendNewEmailDialog_cc"
        [dialogData]="data.dialogData"
        [recipientsGroup]="recipientsGroups.cc">
      </app-add-recipients>
    </div>
  </mat-expansion-panel>

  <!-- Add Bcc -->
  <mat-expansion-panel
    class="info-panel remove-mat-expansion-panel-padding"
    (opened)="addBccOpenState = true"
    (closed)="addBccOpenState = false"
    [expanded]="addBccOpenState">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <div class="section-header-container">
          <p class="overline grey1 semibold section-title">
            {{data.sysText.sendNewEmailDialog_addBcc}}
            @if (form.controls.bcc.controls.recipientBoxChips.value.length > 0) {
              <span class="grey3 caption">
                {{ form.controls.bcc.controls.recipientBoxChips.value.length }} selected
              </span>
            }
          </p>
          <mat-divider class="section-header-underline" aria-hidden="true"></mat-divider>
        </div>
      </mat-panel-title>
    </mat-expansion-panel-header>

    <div class="panel-content">
      <app-add-recipients
        [formGroup]="form.controls.bcc"
        [sysText]="data.sysText"
        [boxLabel]="data.sysText.sendNewEmailDialog_bcc"
        [dialogData]="data.dialogData"
        [recipientsGroup]="recipientsGroups.bcc">
      </app-add-recipients>
    </div>
  </mat-expansion-panel>

  <!-- Email Content -->
  <mat-expansion-panel
    class="info-panel remove-mat-expansion-panel-padding tiny-editor-panel"
    (opened)="emailContentOpenState = true"
    (closed)="emailContentOpenState = false"
    [expanded]="emailContentOpenState">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <div class="section-header-container">
          <p class="overline grey1 semibold section-title">{{data.sysText.sendNewEmailDialog_emailContent | uppercase}}</p>
          <mat-divider class="section-header-underline" aria-hidden="true"></mat-divider>
        </div>
      </mat-panel-title>
    </mat-expansion-panel-header>

    <div class="panel-content">
      <app-select-field
        [control]="this.form.controls.templates"
        [label]="data.sysText.sendNewEmailDialog_template"
        [options]="data.dialogData.templateOptions"
        [icon]="'format_list_bulleted'"
        [showBlankOption]="true"
        [shouldCapitalize]="false"
        [showSpinner]="(templateIsLoading$ | async)">
      </app-select-field>

      <div>
        <div class="editor-container">
          <mat-icon class="section-label">title</mat-icon>
          <p class="grey1">{{data.sysText.sendNewEmailDialog_subjectLine}}</p>
        </div>
        <div class="tiny-editor">
          <app-email-subject-editor
            [control]="form.controls.subject"
            [placeholderText]="data.sysText.sendNewEmailDialog_subjectLine"
            [placeHolders]="data.dialogData.placeholderOptions">
          </app-email-subject-editor>
        </div>
      </div>
      <span class="spacer"></span>
      <div>
        <div class="editor-container">
          <mat-icon class="section-label">subject</mat-icon>
          <p class="grey1">{{data.sysText.sendNewEmailDialog_emailBody}}</p>
        </div>

        <div class="tiny-editor">
          <app-email-body-editor
            [control]="form.controls.body"
            [placeholderText]="data.sysText.sendNewEmailDialog_emailBody"
            [placeHolders]="data.dialogData.placeholderOptions">
          </app-email-body-editor>
        </div>
      </div>
    </div>
  </mat-expansion-panel>

  <!-- Attach Documents -->
  <mat-expansion-panel
    class="info-panel remove-mat-expansion-panel-padding"
    (opened)="attachDocsOpenState = true"
    (closed)="attachDocsOpenState = false"
    [expanded]="attachDocsOpenState">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <div class="section-header-container">
          <p class="overline grey1 semibold section-title">{{data.sysText.sendNewEmailDialog_attachDoc | uppercase}}</p>
          <mat-divider class="section-header-underline" aria-hidden="true"></mat-divider>
        </div>
      </mat-panel-title>
    </mat-expansion-panel-header>

    <div class="panel-content">
      <input hidden type="file" #imgFileInput (change)="handleFileInput($event.target.files)" autocomplete="off"/>
      <div class="file-input-field">
        <button
          #uploadButton
          mat-stroked-button
          color="accent"
          class="button"
          (click)="imgFileInput.click()">
          <mat-icon>upload</mat-icon>
          {{data.sysText.sendNewEmailDialog_uploadDoc | titlecase}}
        </button>
      </div>
      <div aria-live="polite">
        @if (emailTooLarge != null) {
          <mat-error class="body2 upload-error">{{ emailTooLarge }}</mat-error>
        }
      </div>
      @if (attachments) {
        <div class="file-upload-container">
          @for(attachment of attachments; track attachment){
            <div class="file-upload">
              <mat-icon class="fill4-dk">check</mat-icon>
              <div>
                <span class="body2 side-space grey3">{{ attachment.file?.name }}</span>
              </div>
              <button type="button" class="button-reset" [attr.aria-label]="data.sysText.removeFile_ariaLabel" (click)="clearFile(attachment.file)">
                <mat-icon class="black-inactive small">clear</mat-icon>
              </button>
            </div>
          }
        </div>
      }
    </div>
  </mat-expansion-panel>
</mat-dialog-content>

<mat-dialog-actions class="space-between">
  @let isSubmitting = isSubmitting$ | async;
  <!-- preview and send share isSubmitting$, so submittingAction says which one was pressed: that one shows the spinner
  (showProgress) and the "loading" label. both stay focusable while busy (disabledInteractive), and the guards block clicks -->
  <button
    mat-stroked-button
    class="button"
    color="accent"
    [disabled]="isSubmitting"
    disabledInteractive
    [showProgress]="isSubmitting && submittingAction === 'preview'"
    [attr.aria-label]="isSubmitting && submittingAction === 'preview' ? data.sysText.loading_ariaLabel : null"
    (click)="!isSubmitting && onPreview()">
    {{data.sysText.sendNewEmailDialog_preview}}
    <mat-spinner progressIndicator diameter="30" color="accent"></mat-spinner>
  </button>
  <div>
    @if (!(isMobile$ | async)) {
      <button
        mat-stroked-button
        class="button"
        color="accent"
        [disabled]="isSubmitting"
        (click)="close()">
        {{data.sysText.sendNewEmailDialog_cancel}}
      </button>
    }
    <button
      mat-stroked-button
      class="button"
      color="accent"
      [disabled]="isSubmitting"
      disabledInteractive
      [showProgress]="isSubmitting && submittingAction === 'send'"
      [attr.aria-label]="isSubmitting && submittingAction === 'send' ? data.sysText.submitting_ariaLabel : null"
      (click)="!isSubmitting && onSend(false)">
      {{data.sysText.sendNewEmailDialog_send}}
      <mat-spinner progressIndicator diameter="30" color="accent"></mat-spinner>
    </button>
  </div>
</mat-dialog-actions>